(function ($) {
  $.fn.wsCarrousel = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeSlider();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      /*var opt = $.extend({
        delay: 100,
        speed: 10
      }, options);*/


      // Elements
      let carrouselElement;
      let sliderElement;
      let sliderInnerElement;
      let bigItemElement;

      // Variables
      let translateX = 0;
      //let moveX = 0;
      let xSpeed = 0;
      let xDirection = 1;
      let xDistance = 0; // Normalized distance
      let xDistanceMoved = 0; // Normalized moved amount
      //let hover = false;

      //let moveToX = 0;

      let animationFrameId = null;
      let animating = false;

      let animate = function () {
        cancelAnimationFrame(animationFrameId);

        animating = true;

        let _translateX = 0;
        let xDistanceRemaining = xDistance - xDistanceMoved;

        if (xDistanceRemaining !== 0) {
          let xDistanceQuarter = xDistance / 4;
          if (xDistanceRemaining >= xDistanceQuarter * 2) {
            // Acceleration phase
            //console.log('Acceleration');
            xSpeed += 1;
          }
          if (xDistanceRemaining <= xDistanceQuarter) {
            // Deceleration phase
            //console.log('Deceleration');
            xSpeed -= 2;
          }

          if (xSpeed < 1) {
            xSpeed = 1;
          }
        } else {
          xSpeed = 0;
        }

        console.log('translateX: ' + translateX, 'xSpeed:  ' + xSpeed, 'xDistance: ' + xDistance, 'xDistanceMoved: ' + xDistanceMoved, 'xDistanceRemaining: ' + xDistanceRemaining);

        if (xSpeed !== 0) {

          if (xDistanceRemaining > 0) {
            if (xSpeed > xDistanceRemaining) {
              xSpeed = xDistanceRemaining;
            }

            _translateX += xSpeed;
          }

          //translateX = moveElements(inner, translateX);

        }

        if (_translateX > 0) {
          xDistanceMoved += _translateX;
          translateX += _translateX * xDirection;
          moveElements();
          //sliderInnerElement.css('transform', 'translateX(' + translateX/10 + 'rem)');
          sliderInnerElement.css('transform', 'translateX(' + translateX + 'px)');
        } else {
          // Nothing to animate.
          animating = false;
          console.warn('Animation finished.');
        }

        if (animating) {
          animationFrameId = requestAnimationFrame(animate);
        } else{
          showButtons();

          setTimeout(function() {
            carrouselElement.css('touch-action', 'auto');
          }, 1000);
          // sliderInnerElement.css('transform', 'translateX(0px)');
        }
      }


      let moveElements = function () {
        // TODO: keep running this until theres no more elements to move. (in case of fast scrolling)

        let children = sliderInnerElement.children();
        let firstChild = children.first();
        let lastChild = children.last();
        //console.log(firstChild.width());
        if (translateX <= -firstChild.width()) {
          let width = firstChild.width();
          translateX += width;
          //moveToX += width;
          //xDistanceMoved += width;

          console.log('append', 'translateX: ' + translateX, 'xDistanceMoved: ' + xDistanceMoved);
          firstChild.appendTo(sliderInnerElement);

            setBigItem(firstChild);
        } else if (translateX > 0) {
          let width = lastChild.width();
          translateX -= width;
          //moveToX -= width;
          //xDistanceMoved += width;

          console.log('prepend', 'translateX: ' + translateX, 'xDistanceMoved: ' + xDistanceMoved);
          lastChild.prependTo(sliderInnerElement);

            setBigItem(sliderInnerElement.children().last()); // Get new last one.
        }
      }

      let setBigItem = function (el) {
        if (bigItemElement.length === 0) {
          return;
        }

        let backgroundChildren = bigItemElement.children().addClass('background');
        setTimeout(function () {
          backgroundChildren.remove();
        }, 1000);
        let clone = el.clone();
        clone.appendTo(bigItemElement);
        clone.width('');
        setTimeout(function () {
          clone.addClass('big');
        }, 100);
      }


      let bindEvents = function () {
        sliderElement.off();

        sliderElement.hover(
          function () {
            //hover = true;
          },
          function () {
            //hover = false;
          }
        );

        carrouselElement.find('.prev-button').click(function () {
          hideButtons();
          prevItem();
        });

        carrouselElement.find('.next-button').click(function () {
          hideButtons();
          //moveX += -1;
          nextItem();
          //console.log(moveToX);
          //moveToX = -800;
        });

        carrouselElement.on('swiped-right', function() {
          prevItem();
        });

        carrouselElement.on('swiped-left', function() {
          nextItem();
        });

        /*
        //sliderInnerElement.on('click', '.slider-product', function () {
        //  console.log('Start move CLICK - ');
        //  doMoveToX(-Math.round($(this).next().position().left));
        //});
        */
      }

      let prevItem = function () {
        // Using Math.round here because the left position is not rounded, leading to rounding errors elsewhere.
        console.log('Start move PREV - (' + sliderInnerElement.children().last().width() + ')');
        doMoveToX(Math.round(sliderInnerElement.children().last().width()));
      }

      let nextItem = function () {
          if(sliderElement.find('.disableLoop').length !== 0){
            let elementsTotalWidth = 0;
          sliderInnerElement.children().each(function() {
            elementsTotalWidth += $(this).width();
          });

          if(sliderElement.width() > elementsTotalWidth) {
            hideButtons();
            return;
          }
        }

        // Using Math.round here because the left position is not rounded, leading to rounding errors elsewhere.
        console.log('Start move NEXT - (' + -sliderInnerElement.children().first().next().position().left + ')');
        if (!animating){
          doMoveToX(-Math.round(sliderInnerElement.children().first().next().position().left));
        }
      }

      let doMoveToX = function (x) {
        cancelAnimationFrame(animationFrameId);

        if (x < 0) {
          xDirection = -1;
          x = x * -1;
        } else {
          xDirection = 1;
          x -= translateX;
        }

        /* Slides 3 products per animation except for sliders with big items */
        if (bigItemElement.length === 0) {
          xDistance = x * 3;
        }else {
          xDistance = x;

          /* move 3 elements since there is no big item at this screen-width */
          if ($(window).width() <= 1024){
            xDistance = x * 3;
          }
        }

        /* On mobile slide 2 product per animation since the screen is smaller */
        if ($(window).width() <= 640){
          xDistance = x * 2;
        }
        xDistanceMoved = 0;

        console.log(xDistance);

        animate();
      }


      // Resize and make sure there's enough elements.
      let resizeSlider = this.resizeSlider = function () {
        let sliderWidth = $(window).width() - sliderElement.offset().left;
        sliderElement.width(sliderWidth);


        sliderInnerElement.find('.clone').remove();

        // disableLoop

        console.log(sliderElement.find('.disableLoop'));
        if (sliderElement.find('.disableLoop').length === 0) {

          let realItems = sliderInnerElement.children();
          //console.log(realItems);

          if (realItems.length === 0) {
            // No items... skip.
            return;
          }

          realItems.width(''); // Set width to automatic;

          let minimumItems = (sliderWidth / realItems.first().width()) + 1; // TODO: +1 because otherwise you'll see it if theres too few items.
          //console.log(minimumItems);

          while (sliderInnerElement.children().length < minimumItems) {
            realItems.clone().addClass('clone').appendTo(sliderInnerElement);
          }

          let innerWidth = 0;
          sliderInnerElement.children().each((childIterator, childElement) => {
            let width = Math.round($(childElement).width()); // Calculate the width, round it to prevent rounding errors.
            $(childElement).width(width); // Set the pixel width here, as we use it in other places and do not want rounding errors.
            innerWidth += width;
          });
          //console.log(innerWidth);
          sliderInnerElement.width(innerWidth);

        }else{
          if(sliderElement.find('.disableLoop').length !== 0) {
            let elementsTotalWidth = 0;
            sliderInnerElement.children().each(function () {
              elementsTotalWidth += $(this).width();
            });

            if (sliderElement.width() > elementsTotalWidth) {
              hideButtons();
              return;
            }
          }
        }

        carrouselElement.css('min-height', sliderElement.height());

        /* Make sure the carrousel doesn't scroll on mobile */
        if ($(window).width() >= 1024) {
          // In case we do not show a big item yet, lets show one.
          if (bigItemElement.length > 0 && bigItemElement.children().length === 0) {
            nextItem();
          }
        }
      }

      let hideButtons = function () {
        carrouselElement.find('.prev-button').hide();
        carrouselElement.find('.next-button').hide();
      }

      let showButtons = function() {

        if (bigItemElement.length === 0)
        {
          carrouselElement.find('.right > .prev-button').show();
          carrouselElement.find('.right > .next-button').show();
        }else {
          if ($(window).width() <= 1024) {
            carrouselElement.find('.right > .prev-button').show();
            carrouselElement.find('.right > .next-button').show();
          }else {
            carrouselElement.find('.left > .prev-button').show();
            carrouselElement.find('.left > .next-button').show();
          }
        }
      }

      let stopScrolling = function(carrouselElementParameter) {
        carrouselElement = $(carrouselElementParameter);

        carrouselElement.on('swiped-left', function () {
          carrouselElement.css('touch-action', 'none');
        });

        carrouselElement.on('swiped-right', function () {
          carrouselElement.css('touch-action', 'none');
        });
      }


      let initialize = function (carrouselElementParameter) {
        carrouselElement = $(carrouselElementParameter);

        if (carrouselElement.data('carrousel')) {
          console.warn('Trying to reinitialize the carrousel for element. Skipping.', carrouselElement);
          return;
        }
        carrouselElement.data('carrousel', this);


        // Find elements and set to variable.
        sliderElement = carrouselElement.find('.slider');
        bigItemElement = carrouselElement.find('.big-item');
        sliderInnerElement = sliderElement.find('.slider-inner');

        if (sliderInnerElement.children().length === 0) {
          console.warn('Carrousel has no elements!', carrouselElement);
          return;
        }

        if (bigItemElement.length !== 0) {
          bigItemElement.children().addClass('big');
        }


        bindEvents();

        resizeSlider();
      };
      stopScrolling(this);
      initialize(this);

      $(window).load(function () {
        resizeSlider();
      });
      $(window).resize(function () {
        resizeSlider();
      });
    });
  };
})(jQuery);
